// extracted by mini-css-extract-plugin
export var infoContainer = "header-module--infoContainer--+aVsG";
export var head = "header-module--head--71mzt";
export var intro = "header-module--intro--txQgA";
export var awards = "header-module--awards--AOKXc";